import React, { useEffect, useRef, useState } from "react";
import ViewTable from "../../../Components/Common/ViewTable";
import { api, get } from "../../../utils/api";
import Cards from "./Cards";
import FilterModal from "../../../Components/Common/FilterModal";
import DeleteDialog from "../../../Components/Masters/DeleteDialog";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import AddData from "./AddData";
import { Box, Typography } from "@mui/material";
import ViewData from "./ViewData";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import WaterManagement from "../../../Layout/WaterManagement";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import { truncateNumber } from "../../../utils/common";
import ActionButtonWithoutUpload from "../../../Components/Common/ActionButtonWithoutUpload";
import { useUser } from "../../../context/AuthContext";
import {
  shouldShowFacilityColumn,
  withFacilityViewTableHeader,
  mapTableDataWithFacility,
} from "../../../utils/facilityColumn";

const WaterMangementMain = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [data, setData] = useState([]);
  const [cardData, setCardData] = useState(null);
  const [totalPages, setTotalPages] = useState("");
  useEffect(() => {
    fetchCardData();
  }, []);

  const fetchCardData = async () => {
    try {
      const response = await get(`/scope3/waterManagement/cardData`);
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  const updatePage = () => {
    if (page > 1 && tableData?.length === 1) {
      setPage(page - 1);
    }
    setIsLoading(true);
    fetchData();
  };
  let bannerData = [
    {
      title: "Total Water Withdrawal",
      description: truncateNumber(cardData?.totalWaterWithdrawal || 0) + " KL",
    },
    {
      title: "Total Wastewater Discharged",
      description: truncateNumber(cardData?.totalWaterDischarged || 0) + " KL",
    },
    {
      title: "Total Wastewater Treated",
      description:
        truncateNumber(cardData?.totalWastewaterTreated || 0) + " KL",
    },
    {
      title: "Total Water Recycled",
      description: truncateNumber(cardData?.totalWaterRecycled || 0) + " KL",
    },
  ];

  const inputData = [
    {
      fieldName: "waterWithdrawal",
      title: "Water Withdrawal by Source",
      type: "array",
      fields: [
        {
          fieldName: "serialNo",
          title: "S. No",
          placeholder: "Number",
          type: "number",
          width: "3.5rem",
        },
        {
          fieldName: "source",
          title: "Source of Water",
          placeholder: "Enter the source (e.g., Surface Water)",
          type: "select",
          width: "10rem",
          options: [
            "Surface Water",
            "Ground Water",
            "Seawater",
            "Industrial Produced Water",
            "Third-party water",
            "Others",
          ],
        },
        {
          fieldName: "quantity",
          title: "Quantity (KL)",
          placeholder: "Number",
          type: "number",
          width: "8rem",
        },
        {
          fieldName: "remarks",
          title: "Remarks",
          placeholder: "Text",
          type: "text",
          width: "7rem",
        },
        {
          fieldName: "documents",
          title: "Document",
          placeholder: "Upload documents",
          type: "file",
          width: "7rem",
        },
      ],
    },
    {
      fieldName: "waterDischarge",
      title: "Water Discharge by Destination",
      type: "array",
      fields: [
        {
          fieldName: "serialNo",
          title: "S. No",
          placeholder: "Number",
          type: "number",
          width: "3.5rem",
        },
        {
          fieldName: "source",
          title: "Destination of Discharge",
          placeholder: "Enter the source of discharge",
          type: "select",
          width: "10rem",
          options: [
            "Surface Water",
            "Ground Water",
            "Seawater",
            "Municipal Treatment Plant - ETP",
            "STP",
            "Others",
            "ETP",
          ],
        },
        {
          fieldName: "quantity",
          title: "Quantity (KL)",
          placeholder: "Number",
          type: "number",
          width: "8rem",
        },
        {
          fieldName: "remarks",
          title: "Remarks",
          placeholder: "Text",
          type: "text",
          width: "7rem",
        },
        {
          fieldName: "documents",
          title: "Document",
          placeholder: "Upload documents",
          type: "file",
          width: "7rem",
        },
      ],
    },
    {
      fieldName: "wastewaterTreatment",
      title: "Wastewater Treatment by Discharge Destination",
      type: "array",
      fields: [
        {
          fieldName: "serialNo",
          title: "S. No",
          placeholder: "Number",
          type: "number",
          width: "3.5rem",
        },
        {
          fieldName: "source",
          title: "Wastewater discharge Destination",
          placeholder: "Enter the source of treatment",
          type: "select",
          width: "10rem",
          options: [
            "Surface Water",
            "Ground Water",
            "Seawater",
            "Municipal Treatment Plant - ETP",
            "STP",
            "Others",
            "ETP",
          ],
        },
        {
          fieldName: "quantity",
          title: "Quantity (KL)",
          placeholder: "Number",
          type: "number",
          width: "7rem",
        },
        {
          fieldName: "treatmentLevel",
          title: "Treatment Level",
          placeholder: "Number",
          type: "select",
          width: "8rem",
          options: ["Primary", "Secondary", "Tertiary"],
        },
        {
          fieldName: "documents",
          title: "Document",
          placeholder: "Upload documents",
          type: "file",
          width: "7rem",
        },
      ],
    },
    {
      fieldName: "waterRecycling",
      title: "Water Circularity",
      type: "array",
      fields: [
        {
          fieldName: "serialNo",
          title: "S. No",
          placeholder: "Number",
          type: "number",
          width: "3.5rem",
        },
        {
          fieldName: "parameter",
          title: "Recycled water usage",
          type: "select",
          width: "10rem",
          options: [
            "Agriculture",
            "Sanitation",
            "Drinking water",
            "Industries",
            "Others",
          ],
          // [
          //   "Total Water Recycled / Reused",
          //   // "Percentage of Water Recycled (%)",
          // ],
        },
        {
          fieldName: "quantity",
          title: "Quantity (KL)",
          placeholder: "Number",
          type: "number",
          width: "7rem",
        },
        {
          fieldName: "treatmentLevel",
          title: "Treatment Level",
          placeholder: "Enter the treatment level",
          type: "select",
          width: "8rem",
          options: ["Primary", "Secondary", "Tertiary"],
        },
        {
          fieldName: "documents",
          title: "Document",
          placeholder: "Upload documents",
          type: "file",
          width: "7rem",
        },
      ],
    },
    {
      fieldName: "interactionWithWater",
      title: "Interaction with Water as a Shared Resource",
      type: "array",
      waterWithdrawalLocations: {
        fields: [
          {
            fieldName: "serialNo",
            title: "S. No",
            placeholder: "Number",
            type: "number",
            width: "3.5rem",
          },
          {
            fieldName: "source",
            title: "Source of Water",
            placeholder: "Enter the source",
            width: "10rem",
            options: [
              "Surface Water",
              "Ground Water",
              "Seawater",
              "Municipal Treatment Plant - ETP",
              "STP",
              "Others",
            ],
            type: "select",
          },
          {
            fieldName: "location",
            title: "Location",
            placeholder: "Text",
            width: "8rem",
            type: "text",
          },
          {
            fieldName: "quantity",
            title: "Quantity (KL)",
            placeholder: "Number",
            type: "number",
            width: "7rem",
          },
          {
            fieldName: "documents",
            title: "Document",
            placeholder: "Upload documents",
            width: "7rem",
            type: "file",
          },
        ],
      },
    },
  ];

  /** Fluid columns — table fills width with no horizontal scroll. */
  const headers = withFacilityViewTableHeader(
    [
      { key: "createdAt", label: "Date", sortable: true, fluidWeight: 0.9 },
      {
        key: "monthYear",
        label: "Consumption Month",
        sortable: true,
        fluidWeight: 1.15,
      },
      {
        key: "waterWithdrawal",
        label: "Water Withdrawl (KL)",
        sortable: true,
        truncate: true,
        fluidWeight: 1.15,
      },
      {
        key: "waterDischarge",
        label: "Wastewater Discharged (KL)",
        sortable: true,
        truncate: true,
        fluidWeight: 1.25,
      },
      {
        key: "wastewaterTreatment",
        label: "Wastewater Treated (KL)",
        sortable: true,
        truncate: true,
        fluidWeight: 1.2,
      },
      {
        key: "waterRecycledAndReused",
        label: "Water Recycled (KL)",
        sortable: true,
        truncate: true,
        fluidWeight: 1.1,
      },
    ],
    showFacilityColumn,
    { fluidWeight: 1.2 },
  );

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      key: "consumptionMonth",
      type: "month",
      title: "Consumption Month",
      sortable: true,
    },
    {
      title: "Water Withdrawn",
      type: "limit",
      key: "waterWithdrawl",
      value: tableData?.waterWithdrawal,
      min: "minWithdrawal",
      max: "maxWithdrawal",
    },
    {
      title: "Water Discharged",
      type: "limit",
      key: "waterDischarge",
      value: tableData?.waterDischarge,
      min: "minDischarge",
      max: "maxDischarge",
    },
    {
      title: "Waste Water Treated",
      type: "limit",
      value: tableData?.wastewaterTreatment,
      key: "wastewaterTreatment",
      min: "minTreatMent",
      max: "maxTreatMent",
    },
    {
      title: "Water Recycled",
      type: "limit",
      key: "waterRecycledAndReused",
      value: tableData?.waterRecycledAndReused,
      min: "minRecyling",
      max: "maxRecyling",
    },
  ];

  const fetchData = async () => {
    try {
      let filter = { ...filterObj };
      fetchCardData();

      filterData.forEach((field) => {
        if (
          filterObj[field.key] &&
          field.key !== "createdAt" &&
          field.key !== "consumptionMonth"
        ) {
          console.log(
            filterObj[field.key],
            filterObj[field.key].min,
            filterObj[field.key].max,
          );
          filter[field.min] = parseInt(filterObj[field.key].min);
          filter[field.max] = parseInt(filterObj[field.key].max);
          delete filter[field.key]; // Remove the original field key (e.g., waterWithDrawn)
        }
      });
      if (filter?.createdAt) {
        filter.startDate = filter?.createdAt?.start || "";
        filter.endDate = filter?.createdAt?.end || "";
        delete filter?.createdAt;
      }
      if (filter?.consumptionMonth) {
        filter.startMonth = filter?.consumptionMonth?.start || "";
        filter.endMonth = filter?.consumptionMonth?.end || "";
        delete filter?.consumptionMonth;
      }

      console.log(filter);
      const queryParams = new URLSearchParams({
        ...filter,
        page: currentPage,
        limit: 10,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
      }).toString();

      const res = await get(`/scope3/waterManagement/listData?${queryParams}`);
      // const res2 = await axios.get(`${api}/scope3/waterManagement/get`);
      console.log("list", res?.data?.data);
      const listData = Array.isArray(res?.data?.data) ? res.data.data : [];
      setTableData(
        listData.map((el) => ({
          ...el,
          monthYear: { month: el._id.month, year: el._id.year },
          waterRecycledAndReused: el.waterRecycledAndReused,
          wastewaterTreatment: el.wastewaterTreatment,
          waterDischarge: el.waterDischarge,
          waterWithdrawal: el.waterWithdrawal,
          totalWaterRecycledAndReused: el.waterRecycledAndReused,
          totalWastewaterTreatment: el.wastewaterTreatment,
          totalWaterDischarge: el.waterDischarge,
          totalWaterWithdrawal: el.waterWithdrawal,
        })),
      );

      setData(Array.isArray(res?.data?.allData) ? res.data.allData : []);
      console.log(tableData, res.data?.data, "element");
      setTotalPages(res.data.pagination.totalPages);
      console.log(res.data.data, res.data.allData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [sortConfig, filterObj, currentPage, page]);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [tableData]);

  const openModal = (type, dataForEdit) => {
    // console.log(dataForEdit,"d123",data.filter((el) => el._id === dataForEdit.id)[0])
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      const matchingData = Array.isArray(data)
        ? data.find((el) => el?._id === dataForEdit?.id)
        : undefined;
      setEditModal(true);
      console.log("check", {
        ...dataForEdit,
        ...matchingData,
      });
      setEditData({
        ...dataForEdit,
        ...matchingData,
      });
      setViewModal(false);
    }
  };

  const handleEdit = () => {
    setViewModal(false);
    setEditModal(true);
  };

  const openViewModal = (dataForView) => {
    // console.log("console",dataForView?.monthYear,data?.map((el) =>el?.monthYear),tableData?.map((el) =>el?.monthYear),
    // );

    // console.log("console",data?.find(el=>el?._id===dataForView?._id))
    const matchingData = Array.isArray(data)
      ? data.find((el) => el?._id === dataForView?.id)
      : undefined;
    setEditData({
      ...dataForView,
      ...matchingData,
    });
    setViewModal(true);
  };

  const handleSort = (key, direction) => {
    setSortConfig({ key, direction });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleFilterChange = (newFilterObj) => {
    setCurrentPage(1);
    setFilterObj(newFilterObj);
    console.log("Applied Filters:", newFilterObj);
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleDeleteOpen = (itemId) => {
    setDeletedItemId(itemId);
    setDeleteDialog(true);
  };
  return (
    <MainDashboardLayout sidebar={<WaterManagement />}>
      <Unauthorized requiredModule="Water management">
        <>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              textDecoration: "underline",
              my: 2,
            }}
          >
            Data Collection
          </Typography>
          <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
            {bannerData.map((el) => (
              <Cards
                title={el.title}
                content={el.description}
                contentMarginTop={
                  el.title === "Total Water Withdrawal" ? "5" : "0"
                }
              />
            ))}
          </Box>
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          <ActionButtonWithoutUpload
            onFilterClick={() => setIsFilterModalOpen(true)}
            onAddClick={() => openModal("add")}
            filterObj={filterObj}
          />
          <ViewTable
            headers={headers}
            data={mapTableDataWithFacility(tableData, showFacilityColumn)}
            onSort={handleSort}
            sortConfig={sortConfig}
            page={currentPage}
            tableContainerRef={tableContainerRef}
            isShortContent={isShortContent}
            title={"Water Data Collection"}
            count={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            tableLayoutAuto
            actionColumnWidthPx={72}
            onView={(row) => {
              openViewModal(row);
            }}
            onEdit={(row) => openModal("edit", row)}
            onDelete={(row) => handleDeleteOpen(row.id)}
          />
          <AddData
            handleClose={() => closeModal(editModal ? "edit" : "add")}
            id={editData ? editData._id : ""}
            title="Data"
            addData={isModalOpen || editModal}
            addUrl={`${api}/scope3/waterManagement/add`}
            updateUrl={`${api}/scope3/waterManagement/update`}
            {...{
              fetchData,
              setsnackOpen,
              inputData,
              element: editData,
              setAddData: setEditModal,
            }}
            data={tableData}
          />
          <ViewData
            id={editData ? editData._id : ""}
            element={editData}
            title="Data"
            viewData={viewModal}
            setData={setEditData}
            setViewData={setViewModal}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: deletedItemId,
                url: `${api}/scope3/waterManagement/delete`,
                setsnackOpen,
              }}
            />
          )}
          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={filterData}
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default WaterMangementMain;
